const variantStyles = {
    default: 'border border-slate-200/80 bg-white shadow-app-sm',
    muted: 'border border-emerald-100 bg-emerald-50',
    dark: 'border border-white/10 bg-white/5 backdrop-blur-sm',
    elevated: 'border border-gray-200 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.06)]',
    interactive: 'border border-slate-200/80 bg-white shadow-app-sm transition-all duration-300 hover:-translate-y-1 hover:border-emerald-200 hover:shadow-app-md',
    'dark-interactive': 'border border-white/10 bg-white/5 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:shadow-2xl',
    'image-overlay': 'border border-gray-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg',
};

export const Card = ({
                         variant = 'default',
                         padding = 'p-5',
                         className = '',
                         children,
                         as: Component = 'div',
                         ...props
                     }) => {
    const baseClasses = `
        overflow-hidden rounded-app
        ${variantStyles[variant] || variantStyles.default}
        ${padding}
        ${className}
    `;

    return (
        <Component className={baseClasses} {...props}>
            {children}
        </Component>
    );
};

export const CardHeader = ({
                               children,
                               className = '',
                               border = true,
                           }) => (
    <div
        className={`flex items-center justify-between ${border ? 'border-b border-gray-100' : ''} p-5 ${className}`}>
        {children}
    </div>
);

export const CardTitle = ({
                              children,
                              className = '',
                              level = 2,
                          }) => {
    const Tag = `h${level}`;
    return (
        <Tag className={`text-lg font-bold text-gray-900 ${className}`}>
            {children}
        </Tag>
    );
};
